module.exports = "/static/assets/0ce2c9db4c2d4b752e43b455d12ce5ed.png";